module.exports={render:function (){
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ( _obj = {
      'vue-bulma-tabs': true
    }, _obj[("is-layout-" + _vm.layout)] = true, _obj )
  }, [_c('div', {
    class: ( _obj$1 = {
      tabs: true
    }, _obj$1[("is-" + _vm.size)] = _vm.size, _obj$1[("is-" + _vm.alignment)] = _vm.alignment, _obj$1[("is-" + _vm.type)] = _vm.type, _obj$1['is-fullwidth'] =  _vm.isFullwidth, _obj$1 )
  }, [_vm._t("left-tab-list"), _vm._v(" "), _c('tab-list', _vm._l((_vm.tabPanes), function(tab, index) {
    return _c('li', {
      class: {
        'is-active': _vm.isActived(index), 'is-disabled': tab.disabled, 'is-flex': true
      },
      attrs: {
        "role": "tab",
        "aria-selected": _vm.isActived(index) ? 'true' : 'false',
        "aria-expanded": _vm.isActived(index) ? 'true' : 'false',
        "aria-disabled": tab.disabled ? 'true' : 'false',
        "selected": _vm.isActived(index),
        "disabled": tab.disabled
      },
      on: {
        "click": function($event) {
          return _vm.select(index)
        }
      }
    }, [_c('a', {
      staticClass: "is-unselectable"
    }, [(tab.icon) ? _c('span', {
      class: ['icon', {
        'is-small': _vm.size !== 'large'
      }]
    }, [_c('i', {
      class: tab.icon
    })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(tab.label))])])])
  }), 0), _vm._v(" "), _vm._t("right-tab-list")], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-content is-flex"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74641df5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bulma-tabs/src/Tabs.vue
// module id = 155
// module chunks = 14